import * as yup from 'yup';

export const optionSchema = yup.object({
  option: yup.string().trim().required('Option name is required'),
  description: yup.string().optional().default(''),
  price: yup
    .number()
    .typeError('Price is required')
    .required('Price is required')
    .min(0, 'Price must be 0 or more'),
});

export const createCustomizationSchema = yup.object({
  customization: yup.string().trim().required('Customization name is required'),
  note: yup.string().default(''),
  quantityEnabled: yup.boolean().required(),
  minQuantity: yup
    .number()
    .nullable()
    .when('quantityEnabled', {
      is: true,
      then: (s) =>
        s
          .required('Minimum quantity is required')
          .test('min-1', 'Must be at least 1', (val) => val != null && val >= 1),
      otherwise: (s) => s.nullable(),
    }),
  maxQuantity: yup
    .number()
    .nullable()
    .when('quantityEnabled', {
      is: true,
      then: (s) =>
        s
          .required('Maximum quantity is required')
          .test('min-1', 'Must be at least 1', (val) => val != null && val >= 1)
          .test('gte-min', 'Maximum cannot be less than minimum', function (max) {
            const { minQuantity } = this.parent;
            if (minQuantity == null || max == null) return true;
            return max >= minQuantity;
          }),
      otherwise: (s) => s.nullable(),
    }),
  multipleSelections: yup.boolean().required(),
  multipleSelectionsQuantity: yup
    .number()
    .nullable()
    .when('multipleSelections', {
      is: true,
      then: (s) =>
        s
          .required('This field is required')
          .test('min-1', 'Must be at least 1', (val) => val != null && val >= 1),
      otherwise: (s) => s.nullable(),
    }),
  soldOut: yup.boolean().required(),
});

export const customizationRulesSchema = yup.object({
  quantityEnabled: yup.boolean().required(),
  minQuantity: yup
    .number()
    .nullable()
    .when('quantityEnabled', {
      is: true,
      then: (s) =>
        s
          .required('Minimum quantity is required')
          .test('min-0', 'Must be at least 0', (val) => val != null && val >= 0),
      otherwise: (s) => s.nullable(),
    }),
  maxQuantity: yup
    .number()
    .nullable()
    .when('quantityEnabled', {
      is: true,
      then: (s) =>
        s
          .required('Maximum quantity is required')
          .test('min-1', 'Must be at least 1', (val) => val != null && val >= 1)
          .test('gte-min', 'Maximum cannot be less than minimum', function (max) {
            const { minQuantity } = this.parent;
            if (minQuantity == null || max == null) return true;
            return max >= minQuantity;
          }),
      otherwise: (s) => s.nullable(),
    }),
  multipleSelections: yup.boolean().required(),
  multipleSelectionsQuantity: yup
    .number()
    .nullable()
    .when('multipleSelections', {
      is: true,
      then: (s) =>
        s
          .required('This field is required')
          .test('min-1', 'Must be at least 1', (val) => val != null && val >= 1),
      otherwise: (s) => s.nullable(),
    }),
  note: yup.string().default(''),
});
